module.exports = __webpack_public_path__ + "static/media/icon-document.9bcfd196.svg";